import { useCallback } from 'react';
import { useAccount, useDisconnect } from 'wagmi';

import { Button } from 'common/components';

import { useI18n, usePopup } from 'common/hooks';
import svgIcons from 'common/svgIcons';

import SvgIconUrl from '../../../SvgIconUrl/SvgIconUrl.component';
import { Web3Wallet } from '../../components/Wallet/Wallet.component';
import './index.css';

export const Web3ConnectSwitchPopup = () => {
  const { connector } = useAccount();
  const { hide } = usePopup();
  const { translate } = useI18n();
  const { disconnectAsync } = useDisconnect();

  const onWalletDisconnect = useCallback(() => {
    disconnectAsync().then(hide);
  }, [disconnectAsync, hide]);

  if (!connector) return null;

  return (
    <div className='web3-connect-switch flex flex-column gap-24'>
      <Web3Wallet key={connector?.id} connector={connector} />
      <div className='web3-connect-switch__info'>
        <SvgIconUrl symbol={svgIcons.InfoIcoInner()} />
        <p>{translate.toText('mobile:wallets:web3:connected:note')}</p>
      </div>
      <Button icon={svgIcons.Web3Chain()} large outline stretch onClick={onWalletDisconnect}>
        {translate.toText('mobile:wallets:web3:disconnect')}
      </Button>
    </div>
  );
};
